import React from "react";
// import { Star } from 'lucide-react';
import { Link } from "react-router-dom";

const TopicTwo = () => {
  const accountTypes = [
    {
      title: "Trading Conditions",
      isPopular: true,
      description:
        "Trade smarter with conditions engineered for speed, stability, and confidence.",
      details: [
        { label: "Minimum trade size", value: "0.01 lots" },
        { label: "Maximum trade size", value: "tier-based up to 50 lots" },
        { label: "Spreads", value: "as low as 0.3 pips (Exclusive)" },
        { label: "Leverage", value: "available on all tiers" },
        {
          label: "Advanced Indicators",
          value: "available from Gold tier and above",
        },
        { label: "Premium Customer Support", value: "Gold tier and above" },
      ],
    },
    // {
    //   title: "Trading Conditions",
    //   isPopular: true,
    //   description:
    //     "Trade smarter with conditions engineered for speed, stability, and confidence.",
    //   details: [
    //     { label: "Minimum trade size", value: "0.01 lots" },
    //     { label: "Maximum trade size", value: "tier-based up to 50 lots" },
    //     { label: "Spreads", value: "as low as 0.3 pips (Exclusive)" },
    //     { label: "Leverage", value: "available on all tiers" },
    //     {
    //       label: "Advanced Indicators",
    //       value: "available from Gold tier and above",
    //     },
    //     { label: "Premium Customer Support", value: "Gold tier and above" },
    //   ],
    // },
  ];

  return (
    <div className="quality-section-trading">
      {/* <div className="quality-header-trading">
        <h1>Standard Accounts: Simple. Powerful. Built for every Trader.</h1>
        <p>
          Trade the world’s most popular markets with spreads built for speed,
          execution built for precision, and account tiers built for your
          growth. Standard Accounts at The Pips give you the perfect balance of
          accessibility and performance, whether you're taking your first trade
          or scaling up your strategy.
        </p>
      </div> */}

      <div className="cards-container">
        {accountTypes.map((account, index) => (
          <div key={index} className="trading-card">
            <div className="card-header">
              <div className="title-row">
                {/* {account.isPopular && <Star className="star-icon" />} */}
                <h2 className="card-title">{account.title}</h2>
              </div>
              <p className="card-description">{account.description}</p>
            </div>

            <div className="divider"></div>

            <div className="details-list">
              {account.details.map((detail, idx) => (
                <div key={idx} className="detail-item">
                  <span className="detail-label">{detail.label}</span>
                  <p className="detail-value">{detail.value}</p>
                </div>
              ))}
            </div>

            <div className="button-container">
              <Link to="/register">
                <button className="register-btn">Register</button>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopicTwo;
